// extracted by mini-css-extract-plugin
export var animationContainer = "_hn-0";
export var asteriskIcon = "_hn-8";
export var conversationLeftSection = "_hn-4";
export var conversationListItem = "_hn-3";
export var conversationMiddleSection = "_hn-5";
export var conversationRightSection = "_hn-6";
export var detailsContent = "_hn-1";
export var listContainer = "_hn-7";
export var modalContent = "_hn-2";